<div class="header">
  <div class="buttons" *ngIf="leftHeaderButtons.length > 0">
    <div *ngFor="let button of leftHeaderButtons; trackBy: trackById">
      <ion-button
        [color]="button.selected || button.primary ? 'primary' : 'secondary'"
        [disabled]="button.disabled"
        [class.selected]="button.selected"
        (click)="onAction(button)"
        [fill]="button.selected ? 'solid' : 'clear'"
      >
        <ion-icon
          *ngIf="button.iconName || button.icon"
          [slot]="!button.label ? 'icon-only' : 'end'"
          [name]="button.iconName"
          [src]="button.icon"
        ></ion-icon>
        {{ button.label }}
      </ion-button>
    </div>
  </div>
  <div class="title">{{ title }}</div>
  <div class="buttons" *ngIf="rightHeaderButtons.length > 0">
    <div *ngFor="let button of rightHeaderButtons; trackBy: trackById">
      <ion-button
        [color]="button.selected || button.primary ? 'primary' : 'secondary'"
        [disabled]="button.disabled"
        [class.selected]="button.selected"
        (click)="onAction(button)"
        [fill]="button.selected ? 'solid' : 'clear'"
      >
        <ion-icon
          *ngIf="button.iconName || button.icon"
          [slot]="!button.label ? 'icon-only' : 'end'"
          [name]="button.iconName"
          [src]="button.icon"
        ></ion-icon>
        {{ button.label }}
      </ion-button>
    </div>
  </div>
</div>
<ion-content class="ion-padding">
  <ng-container #container></ng-container>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div
      slot="start"
      class="footer-buttons"
      *ngIf="leftFooterButtons.length > 0"
    >
      <ion-button
        *ngFor="let button of leftFooterButtons; trackBy: trackById"
        [color]="button.primary ? 'primary' : 'secondary'"
        [disabled]="button.disabled"
        (click)="onAction(button)"
      >
        <ion-icon
          *ngIf="button.iconName || button.icon"
          [slot]="!button.label ? 'icon-only' : 'end'"
          [name]="button.iconName"
          [src]="button.icon"
        ></ion-icon>
        {{ button.label }}
      </ion-button>
    </div>
    <div
      slot="end"
      class="footer-buttons"
      *ngIf="rightFooterButtons.length > 0"
    >
      <ion-button
        *ngFor="let button of rightFooterButtons; trackBy: trackById"
        [color]="button.primary ? 'primary' : 'secondary'"
        [disabled]="button.disabled"
        (click)="onAction(button)"
      >
        <ion-icon
          *ngIf="button.iconName || button.icon"
          [slot]="!button.label ? 'icon-only' : 'end'"
          [name]="button.iconName"
          [src]="button.icon"
        ></ion-icon>
        {{ button.label }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
